export default "__VITE_ASSET__BtNSqAjQ__"